import { useCallback, useEffect, useState } from "react";
import { useConvexAuth } from "convex/react";

import { Splash } from "./splash";

const SEEN_KEY = "mood.intro-seen";

function seen() {
  try {
    return localStorage.getItem(SEEN_KEY) === "1";
  } catch {
    return true;
  }
}

/**
 * The logo's intro played in full, once, the first time someone is signed in
 * on this browser, over whatever page is underneath. Later visits show it
 * only while a page loads. The landing never waits on it: visitors who
 * aren't signed in don't get it. Same rule as the app's first launch
 * (mobile/src/app/_layout.tsx). A click or Escape skips it.
 */
export function FirstIntro() {
  const { isAuthenticated } = useConvexAuth();
  const [seenBefore] = useState(seen);
  const [over, setOver] = useState(false);

  const onDone = useCallback(() => {
    try {
      localStorage.setItem(SEEN_KEY, "1");
    } catch {
      // Private mode: it plays again next time, which is fine.
    }
    setOver(true);
  }, []);

  const showing = isAuthenticated && !seenBefore && !over;
  useEffect(() => {
    if (!showing) return;
    const onKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") onDone();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [showing, onDone]);

  if (!showing) return null;
  return (
    <div className="fixed inset-0 z-[100] bg-paper" onClick={onDone}>
      <Splash onDone={onDone} replay />
    </div>
  );
}
